module.exports = __webpack_public_path__ + "img/globe-05.1a94bd4a.svg";